export default __webpack_public_path__ + "static/media/submit-success.19f43d73.svg";